import { z } from 'zod';
import { StoragePresetIdSchema } from './storage.js';
/** Cloud keys (docs 55, 67, 73): where the user's RunPod, Google Cloud or storage key lives — on a home machine or, opt-in, on Couch. */
export const CloudKeyProviderSchema = z.enum(['runpod', 'gcp', 's3']);
export const CloudKeyHoldersSchema = z.object({
    server: z.object({ set: z.boolean(), updatedAt: z.string().nullable() }),
    machines: z.array(z.object({ id: z.string(), name: z.string(), online: z.boolean() })),
});
const NO_HOLDERS = { server: { set: false, updatedAt: null }, machines: [] };
/** `gcp.projectId`: which project the key on Couch is for (doc 67); `s3`: which provider and bucket (doc 73). */
export const CloudKeysResponseSchema = z.object({
    runpod: CloudKeyHoldersSchema,
    gcp: CloudKeyHoldersSchema.extend({ projectId: z.string().nullable() }).default({ ...NO_HOLDERS, projectId: null }),
    s3: CloudKeyHoldersSchema.extend({ provider: StoragePresetIdSchema.nullable(), bucket: z.string().nullable() }).default({ ...NO_HOLDERS, provider: null, bucket: null }),
});
/** Opt-in only: the user confirms that a key on Couch could reach the whole RunPod account. */
export const SetCloudKeyRequestSchema = z.object({
    key: z.string().trim().regex(/^[A-Za-z0-9_\-.]{8,512}$/, 'That does not look like a RunPod API key'),
    acknowledged: z.literal(true, { message: 'Confirm that you understand what the key can do' }),
});
//# sourceMappingURL=cloud-keys.js.map